// extracted by mini-css-extract-plugin
module.exports = {"menuButton":"menu-module--menuButton--CUNjZ","links":"menu-module--links--333gL","small":"menu-module--small--2wbE2","large":"menu-module--large--1i5ua"};